<template>
  <v-app>
    <component :is="layout" />
  </v-app>
</template>

<script>
  import AppLayout from '../layouts/Members.vue'
  import EmbeddedLayout from '../layouts/Embed.vue'
  import IABFLayout from '../layouts/IABF.vue'
  import PointeLayout from '../layouts/Pointe.vue'

  export default {
    components: {
      'app-layout': AppLayout,
      'embed-layout': EmbeddedLayout,
      'iabf-layout': IABFLayout,
      'pointe-layout': PointeLayout
    },
    computed: {
      layout () {
        return this.$store.getters.layout
      }
    }
  }
</script>
